import { Activity } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectFirstSessionUuid } from '@/store/slices/project/selectors';
import useSpeakersForSession from '@/utils/speakers/use-speakers-for-session';
import Button from '@ui/buttons/button/button';
import useCastAndCrewLayoutType from '../helpers/use-cast-and-crew-layout-type';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import IconToggleV2 from '@ui/icon-toggle/icon-toggle-v2';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import Text from '@ui/text/text/text';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import { useCastAndCrewContext } from '../cast-and-crew-context/use-cast-and-crew-context';

const CastHeaderActions = () => {
  const sessionUuid = useAppSelector(selectFirstSessionUuid);
  const speakers = useSpeakersForSession({ sessionUuid });

  const { dispatch: contextDispatch } = useCastAndCrewContext();

  const { handleViewChange, layout } = useCastAndCrewLayoutType();

  if (!speakers.length) return null;
  return (
    <div className="flex ai-center gap-8">
      <Activity mode={layout === 'list' || (layout === 'grid' && speakers.length >= 4) ? 'visible' : 'hidden'}>
        <Button
          backgroundColor={getThemeColorCSSVariable()}
          hoverBackgroundColor={getThemeColorsCssMixVariable()}
          designSize="small"
          onClick={() => {
            contextDispatch({ type: 'TOGGLE_ADD_CAST_AND_CREW_OPEN', payload: true });
          }}
        >
          <Text className="L2 flex ai-center gap-8" color={getThemeColorContrastCSSVariable()}>
            <Icon name={ICONS.ADD} size={12} /> <span>Add</span>
          </Text>
        </Button>
      </Activity>

      <IconToggleV2
        leftIconName={ICONS.LAYOUT_GRID_4}
        leftValue="grid"
        rightIconName={ICONS.LAYOUT_FLIP_VERTICAL}
        rightValue="list"
        onToggle={handleViewChange}
        selected={layout}
        ariaLabel="Toggle cast and crew layout"
      />
    </div>
  );
};

export default CastHeaderActions;
